import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[notificationsNotificationHost]',
})
export class NotificationHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
